import Swal from 'sweetalert2'
export default Swal.mixin({
  confirmButtonColor: '#1abc9c',
  cancelButtonColor: '#f1556c'
})
